<div *ngIf="showsebpb" style="height:5vh; width: 100% !important; " (click)="quitseb()"><i class="fa fa-sharp fa-power-off" style="float: right !important; margin: 10px;margin-bottom: 0px ; font-size:2rem; cursor: pointer;"></i></div>
<app-loadingdiv #loadingDivComponent></app-loadingdiv>
<!-- background-color: #e9f3fc; -->
<app-webcamaccessnotificationdiv #webcamAccessNotificationDivComponent></app-webcamaccessnotificationdiv>

<app-examiframe #examIframeComponent></app-examiframe>

<app-procteevideomodal #mediaTestModalComponent></app-procteevideomodal>

<app-chatmodal #chatModalComponent></app-chatmodal>